// extracted by mini-css-extract-plugin
export default {"formActionsRow":"FormActionsRow_formActionsRow__VdeQ4","hasChanges":"FormActionsRow_hasChanges__AtL0m"};